import { createContext } from 'react';

const SectionContext = /*#__PURE__*/createContext(null);

export { SectionContext };
